import { HttpResponseBase } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppSettingsService } from '../shared/services/app-settings/app-settings.service';


export abstract class ApiClientBase {
  public url: string;

  constructor() { }

  // protected transformOptions(options: any): any {
  //   // console.log('HTTP call, options: ' + JSON.stringify(options));
  //   return Promise.resolve(options);
  // }

  protected transformResult(
    url: string,
    response: HttpResponseBase,
    processor: (resp: HttpResponseBase) => any
  ): Observable<any> {
    return processor(response);
  }

  protected getBaseUrl(deafultUrl: string): string {
    return AppSettingsService.walletApiUrl;

  }
}
